import { migrateSceneDefinition, validateSceneDefinition } from "../SceneDefinition";
import type { SceneDefinition } from "../SceneDefinition";

/** Import boundary for scene authoring tools. Only `NativeJsonSceneImporter` ships today;
 *  Tiled/LDtk importers can implement this same interface later without touching the runtime. */
export interface SceneImporter<T> {
  import(source: T): SceneDefinition;
}

export class NativeJsonSceneImporter implements SceneImporter<unknown> {
  import(source: unknown): SceneDefinition {
    return migrateSceneDefinition(validateSceneDefinition(source));
  }
}
